/**
 * Single source of truth for Summer Sale copy across pricing, checkout, and
 * soft-urgency popups. WELCOME50 founding chrome stays email-only.
 */
export const SALE_TITLE = "Summer Sale";

/** Soft end date shown in sale chrome (no live countdown). */
export const SALE_END_DATE_LABEL = "Oct 30";

/** Plan-card sale badge. */
export const SALE_BADGE_LABEL = "☆ SUMMER SALE · 60% OFF";

/** Checkout order-summary badge (matches pricing, with Forever). */
export const SALE_CHECKOUT_BADGE_LABEL = "☆ SUMMER SALE · 60% OFF FOREVER";

/** Checkout / email sub-line under the offer heading. */
export const SALE_EXTENSION_SUBTEXT = `Available through ${SALE_END_DATE_LABEL}`;

/** Pricing modal / pop-up sale-box sub-line. */
export const SALE_EXTENSION_SUBTEXT_SHORT = `Available through ${SALE_END_DATE_LABEL}`;

/** Per-plan-card deadline under a badge (space-constrained). */
export const SALE_CARD_DEADLINE_SUBTEXT = `Available through ${SALE_END_DATE_LABEL}`;

/** Urgency band label (kept for any leftover consumers). */
export const SALE_ENDS_BAND_LABEL = `AVAILABLE THROUGH ${SALE_END_DATE_LABEL.toUpperCase()}`;

/**
 * Soft sale is always on for in-app sale chrome (badges / headings).
 * Hard-date gates and countdown timers were removed intentionally.
 */
export const DISCOUNT_END_DATE = new Date(0);

export const isSaleLive = (): boolean => true;

export const getSaleRemainingMs = (): number => 0;
